import { Icon, Space, Typography } from '@sravni/react-design-system';
import { ArrowLeft } from '@sravni/react-icons';
import { useIsMobile } from '@sravni/react-utils';
import cn from 'classnames';
import React from 'react';

import styles from './NavigationHeader.module.scss';

const { Text } = Typography;

interface INavigationHeader {
  size?: 12 | 14 | 16;
  title: string;
  onClick?: () => void;
  className?: string;
}

export const PageHeader = ({ size = 14, title, onClick, className }: INavigationHeader) => {
  const isMobile = useIsMobile();
  return (
    <Space
      size={24}
      direction="vertical"
    >
      <Space>
        <Space
          size={isMobile ? 16 : 32}
          align="center"
        >
          {onClick ? (
            <Space
              align="center"
              size={4}
              onClick={onClick}
              className={cn(styles.link, className)}
            >
              <Icon
                size={20}
                icon={<ArrowLeft />}
              />

              <Text
                strong
                size={size}
              >
                {title}
              </Text>
            </Space>
          ) : (
            <Text
              strong
              size={size}
            >
              {title}
            </Text>
          )}
        </Space>
      </Space>
    </Space>
  );
};
